/**
 * Slider
 *
 * This component requires jQuery and Slick to function.
 * You can require it on the page using <div data-component="slider"></div>
 */

import 'slick-carousel';
$(function () {
  $('[data-component="slider"]').each(function () {
    let $holder = $(this);
    $holder.slick({
      rows: 0,
      infinite: false,
      prevArrow: '<button class="carousel__arrow slick-prev" aria-label="Previous" type="button">‹</button>',
      nextArrow: '<button class="carousel__arrow slick-next" aria-label="Next" type="button">›</button>',
      variableWidth: true,
      swipeToSlide: true
    });
  });
});